import React, { useState, useEffect, useRef } from "react";
import "./SmalltagBox.css"; // Make sure to import the new CSS file

const InputTagsBoxSmall = ({
  label,
  onChange,
  defaultValue = [],
  readonly = false,
  border = "",
  error,
  className = "",
}) => {
  const [tags, setTags] = useState(defaultValue);
  const [inputValue, setInputValue] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [isFocused, setIsFocused] = useState(false);

  const prevDefaultValueRef = useRef(defaultValue);

  useEffect(() => {
    if (
      JSON.stringify(prevDefaultValueRef.current) !==
        JSON.stringify(defaultValue) &&
      JSON.stringify(tags) !== JSON.stringify(defaultValue)
    ) {
      setTags(defaultValue);
      prevDefaultValueRef.current = defaultValue;
    }
  }, [defaultValue, tags]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !readonly) {
      e.preventDefault();
      if (inputValue.trim() !== "") {
        let newTags;
        if (editIndex === null) {
          newTags = [...tags, inputValue.trim()];
        } else {
          newTags = tags.map((tag, index) =>
            index === editIndex ? inputValue.trim() : tag,
          );
          setEditIndex(null);
        }
        setTags(newTags);
        if (JSON.stringify(newTags) !== JSON.stringify(defaultValue)) {
          onChange(newTags);
        }
        setInputValue("");
      }
    }
  };

  const handleRemoveTag = (index) => {
    if (readonly) return;
    const newTags = tags.filter((_, i) => i !== index);
    setTags(newTags);
    if (JSON.stringify(newTags) !== JSON.stringify(defaultValue)) {
      onChange(newTags);
    }
  };

  const handleEditTag = (index) => {
    if (readonly) return;
    setEditIndex(index);
    setInputValue(tags[index]);
  };

  const displayErrors = error ? [error] : [];

  return (
    <div className={`small-tags-input-wrapper ${className}`}>
      <div
        className={`small-tags-input-container ${border} ${inputValue || tags.length || isFocused ? "has-content" : ""}`}
      >
        <div className="small-tags-inner-container">
          {tags.map((tag, index) => (
            <div
              className="small-tag ftw-4 common-text dk-gray"
              key={`${tag}-${index}`}
            >
              <span onClick={() => handleEditTag(index)}>{tag}</span>
              {!readonly && (
                <button
                  type="button"
                  className="small-tag-remove"
                  onClick={() => handleRemoveTag(index)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                  >
                    <path
                      d="M11 1.10786L9.89214 0L5.5 4.39214L1.10786 0L0 1.10786L4.39214 5.5L0 9.89214L1.10786 11L5.5 6.60786L9.89214 11L11 9.89214L6.60786 5.5L11 1.10786Z"
                      fill="#454545"
                    />
                  </svg>
                </button>
              )}
            </div>
          ))}
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            className="small-tags-input common-text ftw-4"
            readOnly={readonly}
          />
        </div>
        <label className="small-tags-placeholder common-text ftw-4">
          {label}
        </label>
      </div>
      {displayErrors.length > 0 && (
        <div className="input-error-message small-tag-error  red posabs">
          {displayErrors[0]}
        </div>
      )}
    </div>
  );
};

export default InputTagsBoxSmall;
